import React, { Component } from 'react';
import { Row, Col, ButtonGroup, Button,
  ButtonDropdown, DropdownToggle, Card, CardHeader, CardBody,
  DropdownMenu, DropdownItem, FormGroup, Label, Input, FormFeedback, Collapse } from 'reactstrap';
import { upperCaseFirstLetter } from '../../helpers/format';
import { ageFromDateOfBirth } from '../../helpers/age';
import { validateName, validateAmount, validateDateOfBirth, validateGender, allValid } from '../../helpers/validation';
import { allowedRelationships } from '../../helpers/data';
import api from '../../api';

class CreateQuote extends Component {
  constructor (props) {
    super(props);
    this.state = {
      addPersonOpen: false,
      loading: false,
      valid: {},
      showAgentDetails: false
    };
  }

  componentWillReceiveProps () {
    this.validate();
  }

  validate () {
    // coverAmount, dateOfBirth, gender
    // spouse: coverAmount, firstName, lastName, dateOfBirth, gender, relationship
    // children: coverAmount, firstName, lastName, dateOfBirth, relationship
    // extendedFamily: coverAmount, firstName, lastName, dateOfBirht, gender, relationship
    const data = this.props.data;
    const valid = {};

    valid.policyholder = {
      coverAmount: validateAmount(data.policyholder.coverAmount),
      dateOfBirth: validateDateOfBirth(data.policyholder.dateOfBirth, 18, 70),
      gender: validateGender(data.policyholder.gender)
    };
    valid.spouseCoverAmount = !data.spouse || validateAmount(data.spouseCoverAmount);
    valid.spouse = !data.spouse || {
      firstName: validateName(data.spouse.firstName),
      lastName: validateName(data.spouse.lastName),
      dateOfBirth: validateDateOfBirth(data.spouse.dateOfBirth, 18, 70),
      gender: validateGender(data.spouse.gender),
      relationship: true // assume only valid options available
    };
    valid.childrenCoverAmount = data.children.length === 0 || validateAmount(data.childrenCoverAmount);
    valid.children = data.children.map(c => ({
      firstName: validateName(c.firstName),
      lastName: validateName(c.lastName),
      dateOfBirth: validateDateOfBirth(c.dateOfBirth, 0, 21),
      relationship: true // assume only valid options available
    }));
    valid.extendedFamilyCoverAmount = data.extendedFamily.length === 0 || validateAmount(data.extendedFamilyCoverAmount);
    valid.extendedFamily = data.extendedFamily.map(m => ({
      firstName: validateName(m.firstName),
      lastName: validateName(m.lastName),
      dateOfBirth: validateDateOfBirth(m.dateOfBirth, 0, 80),
      gender: validateGender(m.gender),
      relationship: true // assume only valid options available
    }));

    valid.agent = {
      agentCode: true
    };

    this.setState({ valid });

    return allValid(valid);
  }

  isValid (path) {
    const valid = this.state.valid;
    return !this.state.clicked || !!path.reduce((acc, curr) => acc && acc[curr], valid);
  }

  updateField (path, value) {
    const data = this.props.data;
    path.reduce((acc, curr, i) => {
      if (i === path.length - 1) {
        acc[curr] = value;
      } else {
        return acc[curr];
      }
    }, data);
    this.props.setData(data);
  }

  getValue (path) {
    const data = this.props.data;
    return path.reduce((acc, curr) => acc && acc[curr], data);
  }

  getQuote () {
    this.setState({ clicked: true });
    const isValid = this.validate();
    if (!isValid) {
      return;
    }
    this.setState({ loading: true });
    const data = this.props.data;
    const children = data.children.map(c => ({
      age: ageFromDateOfBirth(c.dateOfBirth)
    }));
    const extendedFamily = data.extendedFamily.map(m => ({
      age: ageFromDateOfBirth(m.dateOfBirth),
      gender: m.gender
    }));
    const spouse = data.spouse && {
      age: ageFromDateOfBirth(data.spouse.dateOfBirth),
      gender: data.spouse.gender
    };
    const quoteData = {
      cover_amount: data.policyholder.coverAmount,
      age: ageFromDateOfBirth(data.policyholder.dateOfBirth),
      spouse_included: !!data.spouse,
      spouse,
      spouse_cover_amount: data.spouseCoverAmount,
      children_included: data.children.length > 0,
      children_cover_amount: data.childrenCoverAmount,
      children,
      extended_family_included: data.extendedFamily.length > 0,
      extended_family_cover_amount: data.extendedFamilyCoverAmount,
      extended_family: extendedFamily,
      gender: data.policyholder.gender
    };

    api.getQuote('oats', quoteData)
      .then(r => {
        this.props.setData({ ...data, quote: { ...r[0] } });
        this.props.nextStep();
      })
      .catch(e => {
        console.log('ERROR', JSON.stringify(e, null, 2));
        this.setState({ loading: false });
      });
  }

  handleAddFamily (type) {
    let state = this.props.data;
    switch (type) {
      case 'spouse':
        state.spouse = { type: 'spouse' };
        break;
      case 'child':
        state.children.push({ type: 'child' });
        break;
      default:
        state.extendedFamily.push({ type });
        break;
    }
    this.props.setData(state);
  }

  handleRemoveFamily (type, index) {
    let state = this.props.data;
    switch (type) {
      case 'spouse':
        state.spouse = undefined;
        break;
      case 'child':
        state.children.splice(index, 1);
        if (state.children.length < 1) {
          state.childrenCoverAmount = undefined;
        }
        break;
      case 'all-children':
        state.children = [];
        state.childrenCoverAmount = undefined;
        break;
      case 'all-family':
        state.extendedFamily = [];
        state.extendedFamilyCoverAmount = undefined;
        break;
      default:
        state.extendedFamily.splice(index, 1);
        if (state.extendedFamily.length < 1) {
          state.extendedFamilyCoverAmount = undefined;
        }
        break;
    }
    this.props.setData(state);
  }

  getBasePath (type, index) {
    switch (type) {
      case 'spouse':
        return ['spouse'];
      case 'child':
        return ['children', index];
      default:
        return ['extendedFamily', index];
    }
  }

  ageMessage (type) {
    switch (type) {
      case 'spouse':
        return 'Age must be between 18 and 70';
      case 'child':
        return 'Age must be less than or equal to 21';
      default:
        return 'Age must be less than or equal to 80';
    }
  }

  renderFamilyMember (member, index) {
    let relationship = allowedRelationships.find(r => r.key === member.type);
    const basePath = this.getBasePath(member.type, index);
    return <div key={member + index}>
      <hr />
      <p>
        <b>{(relationship && relationship.val) || upperCaseFirstLetter(member.type)}'s details</b>
        {
          member.type === 'spouse'
            ? undefined
            : <Button
              color='link'
              className='float-right p-0'
              onClick={this.handleRemoveFamily.bind(this, member.type, index)}>
              Remove
            </Button>
        }
      </p>
      <Row>
        <Col sm='6'>
          <FormGroup>
            <Label for='firstName'>First name*</Label>
            <Input
              type='text'
              invalid={!this.isValid([...basePath, 'firstName'])}
              value={this.getValue([...basePath, 'firstName'])}
              onChange={e => this.updateField([...basePath, 'firstName'], e.target.value)}
              id='firstName'
              placeholder='Enter first name' />
            <FormFeedback>A valid first name is required</FormFeedback>
          </FormGroup>
        </Col>
        <Col sm='6'>
          <FormGroup>
            <Label for='lastName'>Last name*</Label>
            <Input
              type='text'
              invalid={!this.isValid([...basePath, 'lastName'])}
              value={this.getValue([...basePath, 'lastName'])}
              onChange={e => this.updateField([...basePath, 'lastName'], e.target.value)}
              id='lastName'
              placeholder='Enter last name' />
            <FormFeedback>A valid last name is required</FormFeedback>
          </FormGroup>
        </Col>
        <Col sm='6'>
          <FormGroup>
            <Label for='dateOfBirth'>Date of birth*</Label>
            <Input
              type='date'
              invalid={!this.isValid([...basePath, 'dateOfBirth'])}
              value={this.getValue([...basePath, 'dateOfBirth'])}
              onChange={e => this.updateField([...basePath, 'dateOfBirth'], e.target.value)}
              id='dateOfBirth'
              placeholder='Select date' />
            <FormFeedback>{this.ageMessage(member.type)}</FormFeedback>
          </FormGroup>
        </Col>
        <Col sm='6'>
          {
            member.type === 'child'
              ? undefined
              : <FormGroup>
                <Label>Gender*</Label>
                <GenderSelect
                  onChange={g => this.updateField([...basePath, 'gender'], g)}
                  invalid={!this.isValid([...basePath, 'gender'])}
                  value={this.getValue([...basePath, 'gender'])}
                />
              </FormGroup>
          }
        </Col>
        <Col sm='6'>
          <FormGroup>
            <Label for='relationship'>Relationship*</Label>
            <Input
              type='select'
              name='select'
              id='relationship'
              disabled={member.type === 'spouse' || member.type === 'child'}
              defaultValue={member.type}
              onChange={e => this.updateField([...basePath, 'type'], e.target.value)}
            >
              {
                member.type.toLowerCase() === 'spouse' || member.type.toLowerCase() === 'child'
                  ? <option>{member.type}</option>
                  : allowedRelationships.map(r => <option
                    key={r.key}
                    value={r.key}>
                    {r.val}
                  </option>)
              }
            </Input>
          </FormGroup>
        </Col>
      </Row>
    </div>;
  }

  renderAgentDetails () {
    return <Row>
      <Col sm='6'>
        <Collapse isOpen={this.state.showAgentDetails}>
          <FormGroup>
            <Label for='agentCode'>Agent code</Label>
            <Input
              name='agentCode'
              id='agentCode'
              placeholder='Enter an agent code'
              invalid={!this.isValid(['agent', 'agentCode'])}
              value={this.getValue(['agent', 'agentCode'])}
              onChange={e => this.updateField(['agent', 'agentCode'], e.target.value)}
            />
          </FormGroup>
        </Collapse>
      </Col>
    </Row>;
  }

  render () {
    return <div>
      <h1>Get a quote</h1>
      <br />
      <h5>Your details</h5>
      <br />

      <FormGroup>
        <Label>Select cover amount*</Label>
        <CoverSelect
          covers={[1000000, 1500000, 2500000, 5000000, 7500000, 10000000]}
          value={this.getValue(['policyholder', 'coverAmount'])}
          onChange={coverAmount => this.updateField(['policyholder', 'coverAmount'], coverAmount)}
          invalid={!this.isValid(['policyholder', 'coverAmount'])}
        />
      </FormGroup>

      <br />

      <Row>
        <Col sm='6'>
          <FormGroup>
            <Label for='dateOfBirth'>Date of birth*</Label>
            <Input
              type='date'
              value={this.getValue(['policyholder', 'dateOfBirth']) || ''}
              onChange={e => this.updateField(['policyholder', 'dateOfBirth'], e.target.value)}
              invalid={!this.isValid(['policyholder', 'dateOfBirth'])}
              id='dateOfBirth'
              placeholder='Select date' />
            <FormFeedback>Age must be between 18 and 70</FormFeedback>
          </FormGroup>
        </Col>
        <Col sm='6'>
          <FormGroup>
            <Label>Gender*</Label>
            <GenderSelect
              value={this.getValue(['policyholder', 'gender'])}
              onChange={gender => this.updateField(['policyholder', 'gender'], gender)}
              invalid={!this.isValid(['policyholder', 'gender'])}
            />
          </FormGroup>
        </Col>
      </Row>

      { this.props.data.spouse
        ? <Card className='mt-4'>
          <CardHeader>
            Included spouse
            <Button
              color='link'
              className='float-right p-0'
              onClick={this.handleRemoveFamily.bind(this, 'spouse')}>
              Remove
            </Button>
          </CardHeader>
          <CardBody>
            <FormGroup>
              <Label>Select cover amount*</Label>
              <CoverSelect
                covers={[1000000, 1500000, 2500000, 5000000, 7500000, 10000000]}
                invalid={!this.isValid(['spouseCoverAmount'])}
                onChange={cover => this.updateField(['spouseCoverAmount'], cover)}
                value={this.getValue(['spouseCoverAmount'])}
              />
            </FormGroup>
            { this.renderFamilyMember(this.props.data.spouse) }
          </CardBody>
        </Card>
        : null
      }
      { this.props.data.children.length > 0
        ? <Card className='mt-4'>
          <CardHeader>
            Included children
            <Button
              color='link'
              className='float-right p-0'
              onClick={this.handleRemoveFamily.bind(this, 'all-children')}>
              Remove all
            </Button>
          </CardHeader>
          <CardBody>
            <FormGroup>
              <Label>Select cover amount*</Label>
              <CoverSelect
                covers={[1000000, 1500000, 2500000, 5000000, 7500000, 10000000]}
                invalid={!this.isValid(['childrenCoverAmount'])}
                value={this.getValue(['childrenCoverAmount'])}
                onChange={cover => this.updateField(['childrenCoverAmount'], cover)}
              />
            </FormGroup>
            { this.props.data.children.map((c, i) => this.renderFamilyMember(c, i)) }
          </CardBody>
        </Card>
        : null
      }
      { this.props.data.extendedFamily.length > 0
        ? <Card className='mt-4'>
          <CardHeader>
            Included extended family
            <Button
              color='link'
              className='float-right p-0'
              onClick={this.handleRemoveFamily.bind(this, 'all-family')}>
              Remove all
            </Button>
          </CardHeader>
          <CardBody>
            <FormGroup>
              <Label>Select cover amount*</Label>
              <CoverSelect
                covers={[1000000, 1500000, 2500000, 5000000, 7500000, 10000000]}
                invalid={!this.isValid(['extendedFamilyCoverAmount'])}
                value={this.getValue(['extendedFamilyCoverAmount'])}
                onChange={cover => this.updateField(['extendedFamilyCoverAmount'], cover)}
              />
            </FormGroup>
            { this.props.data.extendedFamily.map((c, i) => this.renderFamilyMember(c, i)) }
          </CardBody>
        </Card>
        : null
      }

      <hr />

      <ButtonDropdown
        isOpen={this.state.addPersonOpen}
        toggle={() => this.setState({addPersonOpen: !this.state.addPersonOpen})}>
        <DropdownToggle
          caret={false}
          color='link'>
          + Add another person
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            onClick={this.handleAddFamily.bind(this, 'spouse')}
            disabled={!!this.props.data.spouse}>
            Add spouse
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem
            onClick={this.handleAddFamily.bind(this, 'child')}>
            Add child
          </DropdownItem>
          <DropdownItem divider />
          {allowedRelationships.map(r => <DropdownItem
            onClick={this.handleAddFamily.bind(this, r.key)}
            key={r.key}>
            Add {r.val}
          </DropdownItem>)}
        </DropdownMenu>
      </ButtonDropdown>

      <br />

      <Row>
        <Col sm='6'>
          <FormGroup>
            <Button
              color='link'
              onClick={e => { e.preventDefault(); this.setState({ showAgentDetails: !this.state.showAgentDetails }); }}>
              + Add agent details (for agent use only)
            </Button>
          </FormGroup>
        </Col>
      </Row>

      {this.renderAgentDetails()}
      <br />
      <br />

      <Button color='primary' className='px-5' onClick={this.getQuote.bind(this)} disabled={this.state.loading}>{this.state.loading ? 'Loading...' : 'Create quote!'}</Button>
    </div>;
  }
}

export default CreateQuote;

class CoverSelect extends Component {
  constructor (props) {
    super(props);
    this.state = {
      selected: props.value
    };
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.value) {
      this.setState({ selected: nextProps.value });
    }
  }
  handleSelect (amount) {
    if (this.props.onChange) {
      this.props.onChange(amount);
    }
  }
  render () {
    return <div>
      <div className='d-flex'>
        {
          this.props.covers.map((c, i) =>
            <div className='w-100 px-1' key={c}>
              <Button
                color='light'
                active={this.state.selected === c}
                block
                onClick={() => this.handleSelect(c)}>
              R{Math.round(c / 100 / 1000)}k
              </Button>
            </div>
          )
        }
      </div>
      <Input hidden invalid={this.props.invalid} />
      <FormFeedback>A valid cover amount is expected</FormFeedback>
    </div>;
  }
}

class GenderSelect extends Component {
  constructor (props) {
    super(props);
    this.state = {
      selected: props.value
    };
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.value) {
      this.setState({ selected: nextProps.value });
    }
  }
  handleSelect (g) {
    if (this.props.onChange) {
      this.props.onChange(g);
    }
  }
  render () {
    return <div>
      <ButtonGroup className='d-flex'>
        <Button
          active={this.state.selected === 'male'}
          onClick={() => this.handleSelect('male')}
          color='light'
          className='w-100'>
          Male
        </Button>
        <Button
          active={this.state.selected === 'female'}
          onClick={() => this.handleSelect('female')}
          color='light'
          className='w-100'>
          Female
        </Button>
      </ButtonGroup>
      <Input hidden invalid={this.props.invalid} />
      <FormFeedback>A valid gender is required</FormFeedback>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/application/create-quote.js